import { render } from "./DragSelect.vue?vue&type=template&id=6b20af17&scoped=true"
import script from "./DragSelect.vue?vue&type=script&lang=js"
export * from "./DragSelect.vue?vue&type=script&lang=js"

import "./DragSelect.vue?vue&type=style&index=0&id=6b20af17&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b20af17"]])

export default __exports__